import { testimonials } from '@/mocks/manga';

const principles = [
  { icon: 'ri-stack-fill', title: '分类清晰', desc: '按主题整理作品库，热门、最新、排行一目了然。' },
  { icon: 'ri-fire-fill', title: '热度聚焦', desc: '人气排行与热门推荐持续刷新，帮你发现值得追的作品。' },
  { icon: 'ri-refresh-line', title: '持续扩充', desc: '作品库每日更新扩充，找漫画更省时、选择更丰富。' },
  { icon: 'ri-customer-service-2-fill', title: '反馈及时', desc: '遇到信息不符或找不到的作品，欢迎随时反馈修正。' },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
              <i className="ri-heart-3-fill" /> 关于我们
            </span>
            <h2 className="font-display mt-3 text-2xl font-bold text-foreground-900 md:text-4xl">
              嘿休漫画网址，为热爱漫画的你而生
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              嘿休漫画网址聚合全站漫画资源，以分类、人气排行、热门推荐为核心组织方式，
              帮你把海量作品整理得井井有条。不管你是热血冒险党、恋爱甜宠控，
              还是悬疑推理迷、治愈日常派，都能在这里快速找到想看的内容。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们的内容原则很简单：分类清楚、排行真实、更新及时。作品库持续扩充，
              力求让每一次浏览都更省时、更高效，让找漫画这件事回归轻松本身。
            </p>

            <div className="mt-7 grid gap-4 sm:grid-cols-2">
              {principles.map((p) => (
                <div
                  key={p.title}
                  className="flex gap-3 rounded-lg border border-background-200 bg-background-50 p-4"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-lg text-primary-700">
                    <i className={p.icon} />
                  </span>
                  <div>
                    <h3 className="font-display text-base font-bold text-foreground-900">{p.title}</h3>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-7">
            <h3 className="font-display flex items-center gap-2 text-lg font-bold text-foreground-900">
              <i className="ri-chat-quote-fill text-accent-500" />
              读者口碑
            </h3>
            <div className="mt-5 grid gap-4 sm:grid-cols-2">
              {testimonials.map((t) => (
                <figure
                  key={t.name}
                  className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-4"
                >
                  <div className="flex gap-0.5 text-accent-500">
                    {Array.from({ length: t.stars }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm" />
                    ))}
                  </div>
                  <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                    “{t.text}”
                  </blockquote>
                  <figcaption className="mt-4 border-t border-background-200 pt-3">
                    <p className="font-display text-sm font-bold text-foreground-900">{t.name}</p>
                    <p className="mt-0.5 text-xs text-foreground-500">{t.role}</p>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}